module.exports = __webpack_public_path__ + "assets/arrow-right.16882bd0.svg";